import { render, staticRenderFns } from "./PrintableBallotHeader.vue?vue&type=template&id=68e87b61&"
import script from "./PrintableBallotHeader.vue?vue&type=script&lang=js&"
export * from "./PrintableBallotHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports